import { useMemo } from 'react';
import get from 'lodash/get';
import { useAppSelector } from '../../../hooks/useAppStore';
import { getAuthenticateUser } from '../../../store/authenticate/selectors';
import { getManagerPermissions } from '../../../store/settings/selectors';
import { usePermissions } from '../../../hooks/useCommon';

export function useCommissionedSalesPermissions() {
  const { personnel } = useAppSelector(getAuthenticateUser); // Get the authenticated user's role
  const settings = useAppSelector(getManagerPermissions); // Get manager permissions from the store
  const { permissions: localPermissions } = usePermissions(); // General permissions (isAdmin, isEmployee)

  const commissionedSalesPermissions = useMemo(() => {
    const isManager = personnel.permissionLevel === 'Manager'; // Determine if the user is a manager

    const canManageCommissionedSales = get(settings, 'actions.commissionSales.manage'); // Check if the manager can manage commissioned sales
    const canViewCommissionedSales = get(settings, 'visibility.commissionSales.view'); // Check if the manager can view commissioned sales

    return {
      isAllowManage: localPermissions.isAdmin || (isManager && canViewCommissionedSales && canManageCommissionedSales), // Managers need both view + manage permissions for commissioned sales
      isAllowViewCommissionedSales: localPermissions.isAdmin || (isManager && canViewCommissionedSales), // Managers need the visibility permission to view commissioned sales
    };
  }, [personnel.permissionLevel, settings, localPermissions]);

  return {
    commissionedSalesPermissions,
  };
}
